module.exports = __webpack_public_path__ + "static/media/image-card-8.1a1edfc9.png";